(function () {
  "use strict";
  var CFG = window.CRT_CONFIG || {};
  var BASE = (CFG.base || "").replace(/\/$/, "");
  if (!BASE) return;
  var HANDOFF = BASE + "/handoff";
  var VARIANTS = BASE + "/variants";
  var root = document.getElementById("crt");
  if (!root) return;

  var sessionId = "rt_" + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
  var orders = CFG.orders || [];
  var policy = CFG.policy || {};

  // ミニマルなラインアイコン(絵文字は使わない)。
  var SVG = function (p) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' + p + "</svg>"; };
  var ICONS = {
    ret: SVG('<path d="M9 14 4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/>'),
    exc: SVG('<path d="M16 3l4 4-4 4"/><path d="M20 7H9a5 5 0 0 0-5 5"/><path d="M8 21l-4-4 4-4"/><path d="M4 17h11a5 5 0 0 0 5-5"/>'),
    def: SVG('<path d="M12 3.5 2.5 20.5h19L12 3.5z"/><path d="M12 10v4.5"/><path d="M12 18h.01"/>'),
    ec: SVG('<path d="M6.5 8h11l-1 12h-9l-1-12z"/><path d="M9 8a3 3 0 0 1 6 0"/>'),
    store: SVG('<path d="M4 10h16v10H4z"/><path d="M3 5h18l-1.2 5H4.2L3 5z"/><path d="M10 20v-5h4v5"/>'),
    ship: SVG('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7.5" cy="17.5" r="1.6"/><circle cx="17.5" cy="17.5" r="1.6"/>')
  };
  var KIND = {
    "return": { icon: "ret", label: "返品する", desc: "ご購入品を返品します" },
    "exchange": { icon: "exc", label: "交換する", desc: "サイズ・カラーの変更" },
    "defect_inuse": { icon: "def", label: "商品の不良", desc: "商品の不具合のご相談" }
  };
  // 画像URLを正規化(空/プロトコル相対に対応)。
  function imgSrc(s) { s = String(s || ""); if (!s) return ""; if (s.indexOf("//") === 0) return "https:" + s; if (!/^https?:/.test(s)) return ""; return s; }
  var EX_REASON = [
    { v: "none", label: "交換しない" },
    { v: "size", label: "サイズ変更" },
    { v: "color", label: "カラー変更" },
    { v: "initial_defect", label: "初期不良" }
  ];
  var RETURN_REASON = [
    { v: "", label: "選択してください（任意）" },
    { v: "size_ng", label: "サイズが合わない" },
    { v: "image_ng", label: "イメージ違い" },
    { v: "other", label: "その他" }
  ];

  // ---- state ----
  var S = { kind: null, place: null, order: null, order_number: null, store_name: null, receipt: null,
    ex: {}, sel: {}, return_reason: "", receive: null, receive_store: "",
    manual: { item: "", color: "", size: "", change: "" } };

  // ---- helpers ----
  function el(tag, cls, html) { var n = document.createElement(tag); if (cls) n.className = cls; if (html != null) n.innerHTML = html; return n; }
  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function optKind(name) { if (/size|サイズ/i.test(name)) return "size"; if (/colou?r|カラー|色/i.test(name)) return "color"; return null; }
  function exchangeChoices(data, variantTitle, reason) {
    var names = data.optionNames || [], want = reason === "size" ? "size" : "color", targetName = null, otherName = null;
    names.forEach(function (n) { if (optKind(n) === want && !targetName) targetName = n; });
    names.forEach(function (n) { if (n !== targetName && !otherName) otherName = n; });
    var cur = null; (data.variants || []).some(function (v) { if (v.title === variantTitle) { cur = v; return true; } return false; });
    var current = cur && targetName ? cur.options[targetName] : null;
    var otherVal = cur && otherName ? cur.options[otherName] : null;
    var seen = {}, values = [];
    if (targetName) (data.variants || []).forEach(function (v) {
      if (!v.available) return;
      if (otherName && otherVal && v.options[otherName] !== otherVal) return;
      var val = v.options[targetName]; if (val == null) return;
      if (current && val === current) return;
      if (seen[val]) return; seen[val] = 1; values.push(val);
    });
    return { values: values, current: current };
  }
  var _vcache = {};
  function fetchVariants(handle, cb) {
    if (_vcache[handle] !== undefined) return cb(_vcache[handle]);
    fetch(VARIANTS + "?handle=" + encodeURIComponent(handle)).then(function (r) { return r.json(); })
      .then(function (d) { _vcache[handle] = d && d.variants ? d : null; cb(_vcache[handle]); })
      .catch(function () { _vcache[handle] = null; cb(null); });
  }

  // ---- shell ----
  // 遷移方向(前進/戻る)で入場アニメの向きを変える(空間的一貫性)。ヘッダー/ステッパーは据置、内容だけ動く。
  var navDir = "fwd";
  var STEP_LABELS = ["用件", "注文", "商品", "確認"];
  function shell(stepIndex, title, bodyNode, actions) {
    root.innerHTML = "";
    root.appendChild(el("h1", "crt-h", esc(CFG.heading || "返品・交換のお手続き")));
    if (CFG.intro) root.appendChild(el("p", "crt-sub", esc(CFG.intro)));
    var steps = el("div", "crt-steps");
    STEP_LABELS.forEach(function (lab, i) {
      var s = el("div", "crt-step" + (i === stepIndex ? " on" : (i < stepIndex ? " done" : "")), esc(lab));
      steps.appendChild(s);
    });
    root.appendChild(steps);
    var view = el("div", "crt-view " + (navDir === "back" ? "crt-back" : navDir === "none" ? "" : "crt-fwd"));
    if (title) view.appendChild(el("div", "crt-q", esc(title)));
    view.appendChild(bodyNode);
    if (actions) { var a = el("div", "crt-actions crt-sticky"); actions.forEach(function (b) { a.appendChild(b); }); view.appendChild(a); }
    root.appendChild(view);
    navDir = "fwd";
    window.scrollTo({ top: 0, behavior: "smooth" });
  }
  function backBtn(fn) { var b = el("button", "crt-btn crt-btn-ghost", "戻る"); b.onclick = function () { navDir = "back"; fn(); }; return b; }
  function nextBtn(label, fn, enabled) { var b = el("button", "crt-btn crt-btn-primary", esc(label || "次へ")); b.disabled = enabled === false; b.onclick = fn; return b; }

  // ---- step: 用件 ----
  function stepKind() {
    var body = el("div", "crt-opts");
    Object.keys(KIND).forEach(function (k) {
      var o = KIND[k];
      var b = el("button", "crt-opt" + (S.kind === k ? " sel" : ""));
      b.innerHTML = '<span class="crt-opt-ic">' + (ICONS[o.icon] || "") + '</span><span class="crt-opt-tx"><b>' + esc(o.label) + "</b><span>" + esc(o.desc) + "</span></span><span class=\"crt-opt-ch\">›</span>";
      b.onclick = function () { S.kind = k; stepPlace(); };
      body.appendChild(b);
    });
    shell(0, "ご用件をお選びください", body, null);
  }

  // ---- step: 購入場所 ----
  function stepPlace() {
    var pol = policy[S.kind];
    var wrap = el("div");
    if (pol) wrap.appendChild(el("div", "crt-policy", esc(pol)));
    var body = el("div", "crt-opts");
    [["ec", "オンライン(EC)で購入", "ec"], ["store", "実店舗で購入", "store"]].forEach(function (o) {
      var b = el("button", "crt-opt" + (S.place === o[0] ? " sel" : ""));
      b.innerHTML = '<span class="crt-opt-ic">' + (ICONS[o[2]] || "") + '</span><span class="crt-opt-tx"><b>' + esc(o[1]) + "</b></span><span class=\"crt-opt-ch\">›</span>";
      b.onclick = function () {
        S.place = o[0];
        if (o[0] === "store") return stepStore();
        if (CFG.loggedIn && orders.length) return stepOrder();
        return stepManualOrder();
      };
      body.appendChild(b);
    });
    wrap.appendChild(body);
    shell(1, "ご購入場所は？", wrap, [backBtn(stepKind)]);
  }

  // ---- step: 注文選択(EC・ログイン) ----
  function stepOrder() {
    var body = el("div");
    orders.forEach(function (o, oi) {
      var card = el("div", "crt-order");
      var h = el("div", "crt-order-h");
      h.innerHTML = "<b>" + esc(o.date) + " ご購入</b><span class=\"crt-order-d\">" + esc(o.name) + "</span>";
      card.appendChild(h);
      var thumbs = el("div", "crt-thumbs");
      (o.items || []).slice(0, 6).forEach(function (it) {
        var src = imgSrc(it.image); if (src) { var im = el("img", "crt-thumb"); im.src = src; im.alt = ""; im.loading = "lazy"; thumbs.appendChild(im); }
      });
      card.appendChild(thumbs);
      card.onclick = function () { S.order = o; S.order_number = o.name; stepItems(); };
      body.appendChild(card);
    });
    var manual = el("button", "crt-btn crt-btn-ghost", "別の注文・注文番号で");
    manual.style.width = "100%"; manual.style.marginTop = "6px";
    manual.onclick = stepManualOrder;
    body.appendChild(manual);
    shell(1, "対象のご注文をお選びください", body, [backBtn(stepPlace)]);
  }

  // ---- step: 注文番号 手入力 ----
  function stepManualOrder() {
    var body = el("div");
    if (!CFG.loggedIn) body.appendChild(el("div", "crt-note", "ログインすると、ご注文から選ぶだけでお手続きできます。"));
    var f = el("div", "crt-field");
    f.appendChild(el("label", null, "ご注文番号（発送メールに記載の #番号）"));
    var inp = el("input", "crt-input"); inp.type = "text"; inp.placeholder = "例：#1001"; inp.value = S.order_number || "";
    f.appendChild(inp); body.appendChild(f);
    var acts = [backBtn(S.place === "store" ? stepStore : stepPlace)];
    if (CFG.loggedIn) { var lg = el("button", "crt-btn crt-btn-ghost", "注文一覧へ"); lg.onclick = stepOrder; acts.push(lg); }
    acts.push(nextBtn("次へ", function () { S.order_number = inp.value.trim(); S.order = null; stepManualItem(); }));
    shell(1, "ご注文番号をご入力ください", body, acts);
  }

  // ---- step: 実店舗情報 ----
  function stepStore() {
    var body = el("div");
    var f1 = el("div", "crt-field"); f1.appendChild(el("label", null, "ご購入店舗名"));
    var i1 = el("input", "crt-input"); i1.type = "text"; i1.placeholder = "例：イオンモール福岡店"; i1.value = S.store_name || ""; f1.appendChild(i1); body.appendChild(f1);
    var f2 = el("div", "crt-field"); f2.appendChild(el("label", null, "レシート番号・購入日（任意）"));
    var i2 = el("input", "crt-input"); i2.type = "text"; i2.placeholder = "例：No.1234 / 6月20日"; i2.value = S.receipt || ""; f2.appendChild(i2); body.appendChild(f2);
    shell(1, "ご購入店舗の情報", body, [backBtn(stepPlace), nextBtn("次へ", function () {
      if (!i1.value.trim()) { i1.focus(); return; }
      S.store_name = i1.value.trim(); S.receipt = i2.value.trim(); stepManualItem();
    })]);
  }

  // ---- step: 商品 手入力(実店舗/注文番号手入力)。複数商品に対応。 ----
  function stepManualItem() {
    if (!S.manualItems || !S.manualItems.length) S.manualItems = [{ item: "", color: "", size: "", change: "" }];
    var body = el("div");
    if (S.kind === "exchange") body.appendChild(el("div", "crt-note", "交換する商品を入力してください。複数ある場合は「他の商品も入力する」で追加できます。"));
    if (S.kind === "return") body.appendChild(returnReasonField());

    S.manualItems.forEach(function (m, idx) {
      var block = el("div", "crt-manual-item");
      if (S.manualItems.length > 1) {
        var hd = el("div", "crt-manual-hd");
        hd.appendChild(el("span", null, "商品 " + (idx + 1)));
        var rm = el("button", "crt-link-del", "削除");
        rm.onclick = function () { S.manualItems.splice(idx, 1); navDir = "none"; stepManualItem(); };
        hd.appendChild(rm); block.appendChild(hd);
      }
      [["item", "品番 または 商品名", "例：251-1321-09 または ワイドパンツ"], ["color", "カラー", "例：ブラック"], ["size", "サイズ", "例：M"]].forEach(function (fld) {
        var f = el("div", "crt-field"); f.appendChild(el("label", null, fld[1]));
        var inp = el("input", "crt-input"); inp.type = "text"; inp.placeholder = fld[2]; inp.value = m[fld[0]] || "";
        inp.oninput = function () { m[fld[0]] = inp.value; }; f.appendChild(inp); block.appendChild(f);
      });
      if (S.kind === "exchange") {
        var f = el("div", "crt-field"); f.appendChild(el("label", null, "ご希望のサイズ・カラーなど"));
        var inp = el("input", "crt-input"); inp.type = "text"; inp.placeholder = "例：Lサイズに変更"; inp.value = m.change || "";
        inp.oninput = function () { m.change = inp.value; }; f.appendChild(inp); block.appendChild(f);
      }
      body.appendChild(block);
    });

    var add = el("button", "crt-add", "＋ 他の商品も入力する");
    add.onclick = function () { S.manualItems.push({ item: "", color: "", size: "", change: "" }); navDir = "none"; stepManualItem(); };
    body.appendChild(add);

    var backFn = S.place === "store" ? stepStore : stepManualOrder;
    shell(2, "対象商品のご入力", body, [backBtn(backFn), nextBtn(S.kind === "exchange" ? "次へ" : "確認へ", function () {
      if (!(S.manualItems[0] && S.manualItems[0].item.trim())) return;
      S.manualMode = true;
      if (S.kind === "exchange") return stepReceive();
      stepConfirm();
    })]);
  }

  function returnReasonField() {
    var f = el("div", "crt-field"); f.appendChild(el("label", null, "返品の理由（任意）"));
    var sel = el("select", "crt-select");
    RETURN_REASON.forEach(function (r) { var o = el("option", null, esc(r.label)); o.value = r.v; if (r.v === S.return_reason) o.selected = true; sel.appendChild(o); });
    sel.onchange = function () { S.return_reason = sel.value; }; f.appendChild(sel); return f;
  }

  // ---- step: 商品選択(EC・注文あり) ----
  function stepItems() {
    S.manualMode = false;
    var items = (S.order && S.order.items) || [];
    var body = el("div");
    if (S.kind === "return") body.appendChild(returnReasonField());
    if (S.kind === "exchange") body.appendChild(el("div", "crt-note", "交換する商品ごとに理由をお選びください。交換しない商品はそのままで構いません。"));
    else body.appendChild(el("div", "crt-note", "対象の商品にチェックを入れてください。"));

    items.forEach(function (it, idx) {
      var row = el("div", "crt-item");
      var isrc = imgSrc(it.image); if (isrc) { var im = el("img", "crt-item-img"); im.src = isrc; im.alt = ""; im.loading = "lazy"; row.appendChild(im); }
      var b = el("div", "crt-item-b");
      b.appendChild(el("div", "crt-item-t", esc(it.title)));
      if (it.variant && it.variant !== "Default Title") b.appendChild(el("div", "crt-item-v", esc(it.variant)));
      var ctl = el("div", "crt-item-ctl");
      if (S.kind === "exchange") ctl.appendChild(exchangeControl(it, idx));
      else {
        var lab = el("label", "crt-check");
        var cb = el("input"); cb.type = "checkbox"; cb.checked = !!S.sel[idx];
        cb.onchange = function () { S.sel[idx] = cb.checked; refreshNext(); };
        lab.appendChild(cb); lab.appendChild(el("span", null, S.kind === "return" ? "この商品を返品する" : "この商品を対象にする"));
        ctl.appendChild(lab);
      }
      b.appendChild(ctl); row.appendChild(b); body.appendChild(row);
    });

    var next = nextBtn(S.kind === "exchange" ? "次へ" : "確認へ", function () {
      if (S.kind === "exchange") stepReceive(); else stepConfirm();
    });
    root._next = next;
    shell(2, S.kind === "exchange" ? "交換する商品と内容" : "対象の商品を選択", body, [backBtn(stepOrder), next]);
    refreshNext();
  }

  function exchangeControl(it, idx) {
    var wrap = el("div");
    var sel = el("select", "crt-select");
    EX_REASON.forEach(function (r) { var o = el("option", null, esc(r.label)); o.value = r.v; if (S.ex[idx] && S.ex[idx].reason === r.v) o.selected = true; sel.appendChild(o); });
    var chipHost = el("div");
    wrap.appendChild(sel); wrap.appendChild(chipHost);
    sel.onchange = function () {
      var r = sel.value;
      S.ex[idx] = { item: it.title, reason: r, from: null, to: null, handle: it.handle, variant: it.variant };
      chipHost.innerHTML = "";
      if (r === "size" || r === "color") loadChips(it, idx, r, chipHost);
      refreshNext();
    };
    // 既に選択済みなら復元
    if (S.ex[idx] && (S.ex[idx].reason === "size" || S.ex[idx].reason === "color")) loadChips(it, idx, S.ex[idx].reason, chipHost);
    return wrap;
  }

  function loadChips(it, idx, reason, host) {
    host.innerHTML = '<div class="crt-loading">在庫を確認しています…</div>';
    fetchVariants(it.handle, function (vdata) {
      host.innerHTML = "";
      var res = vdata ? exchangeChoices(vdata, it.variant, reason) : { values: [], current: null };
      if (S.ex[idx]) S.ex[idx].from = res.current || "";
      if (!res.values.length) {
        host.appendChild(el("div", "crt-empty", "現在ご用意のある在庫では交換先が見つかりませんでした。担当がご案内しますので、このままお進みください。"));
        if (S.ex[idx]) S.ex[idx].to = "__nostock__";
        refreshNext(); return;
      }
      host.appendChild(el("div", "crt-cur", "現在: " + esc(res.current || "-") + " → 交換後をお選びください"));
      var chips = el("div", "crt-chips");
      res.values.forEach(function (val) {
        var c = el("button", "crt-chip" + (S.ex[idx] && S.ex[idx].to === val ? " on" : ""), esc(val));
        c.onclick = function () {
          S.ex[idx].to = val;
          [].forEach.call(chips.children, function (x) { x.classList.remove("on"); });
          c.classList.add("on"); refreshNext();
        };
        chips.appendChild(c);
      });
      host.appendChild(chips);
    });
  }

  // 「次へ」の活性判定
  function refreshNext() {
    if (!root._next) return;
    var ok = false;
    if (S.kind === "exchange") {
      var any = false, incomplete = false;
      Object.keys(S.ex).forEach(function (k) {
        var e = S.ex[k]; if (!e || e.reason === "none" || !e.reason) return;
        any = true;
        if ((e.reason === "size" || e.reason === "color") && !e.to) incomplete = true;
      });
      ok = any && !incomplete;
    } else {
      ok = Object.keys(S.sel).some(function (k) { return S.sel[k]; });
    }
    root._next.disabled = !ok;
  }

  // ---- step: 受取方法(交換) ----
  function stepReceive() {
    var body = el("div", "crt-opts");
    [["ship", "配送で受け取る", "ship"], ["store", "店舗で受け取る", "store"]].forEach(function (o) {
      var b = el("button", "crt-opt" + (S.receive === o[0] ? " sel" : ""));
      b.innerHTML = '<span class="crt-opt-ic">' + (ICONS[o[2]] || "") + '</span><span class="crt-opt-tx"><b>' + esc(o[1]) + "</b></span><span class=\"crt-opt-ch\">›</span>";
      b.onclick = function () {
        S.receive = o[0];
        if (o[0] === "store") return stepReceiveStore();
        stepConfirm();
      };
      body.appendChild(b);
    });
    var back = S.manualMode ? stepManualItem : stepItems;
    shell(2, "交換品の受け取り方法", body, [backBtn(back)]);
  }
  function stepReceiveStore() {
    var body = el("div");
    var f = el("div", "crt-field"); f.appendChild(el("label", null, "受け取り希望の店舗名"));
    var inp = el("input", "crt-input"); inp.type = "text"; inp.placeholder = "例：イオンモール福岡店"; inp.value = S.receive_store || ""; f.appendChild(inp); body.appendChild(f);
    shell(2, "受け取り店舗", body, [backBtn(stepReceive), nextBtn("確認へ", function () { if (!inp.value.trim()) { inp.focus(); return; } S.receive_store = inp.value.trim(); stepConfirm(); })]);
  }

  // 手入力商品を「品番／カラー／サイズ」文字列に整形。
  function manualLabel(m) { return [m.item, m.color, m.size].map(function (x) { return (x || "").trim(); }).filter(Boolean).join("／"); }
  function manualList() { return (S.manualItems || []).filter(function (m) { return m.item && m.item.trim(); }); }

  // ---- step: 確認 ----
  function buildPayload() {
    var d = { kind: S.kind, place: S.place };
    if (S.place === "store") { d.store_name = S.store_name; if (S.receipt) d.receipt = S.receipt; }
    if (S.order_number) d.order_number = S.order_number;
    if (S.kind === "exchange") {
      if (S.manualMode) {
        // 手入力の交換は複数商品対応。各商品を交換リストの1行にする(希望は自由入力)。
        d.exchanges = manualList().map(function (m) { return { item: manualLabel(m), to: (m.change || "").trim() }; });
      } else {
        var list = [];
        Object.keys(S.ex).forEach(function (k) {
          var e = S.ex[k]; if (!e || !e.reason || e.reason === "none") return;
          var to = e.to === "__nostock__" ? "" : e.to;
          list.push({ item: e.item, reason: e.reason, from: e.from || "", to: to || "" });
        });
        d.exchanges = list;
      }
      d.receive = S.receive; if (S.receive === "store") d.receive_store = S.receive_store;
    } else {
      // 返品 / 商品の不良
      if (S.manualMode) d.product_info = manualList().map(manualLabel).join(" ／ ");
      else {
        var items = (S.order && S.order.items) || [];
        var picked = [];
        Object.keys(S.sel).forEach(function (k) { if (S.sel[k] && items[k]) picked.push(items[k].title); });
        d.product_info = picked.join(" ／ ");
      }
      if (S.kind === "return" && S.return_reason) d.reason = S.return_reason;
    }
    return d;
  }

  function stepConfirm() {
    var d = buildPayload();
    var box = el("div", "crt-summary");
    function row(k, v) { if (!v) return; var r = el("div", "crt-summary-row"); r.innerHTML = '<span class="crt-summary-k">' + esc(k) + "</span>" + esc(v); box.appendChild(r); }
    row("ご用件", KIND[S.kind] ? KIND[S.kind].label : "");
    row("購入場所", S.place === "store" ? "実店舗（" + (S.store_name || "") + "）" : "オンライン(EC)");
    if (S.order_number) row("ご注文番号", S.order_number);
    if (d.product_info) row("商品", d.product_info);
    if (d.exchanges) d.exchanges.forEach(function (e, i) {
      var rl = { size: "サイズ", color: "カラー", initial_defect: "初期不良" }[e.reason] || "";
      var v = e.item;
      if (e.reason === "initial_defect") v += "（初期不良）";
      else if (e.to) v += " ／ " + (rl ? rl + " " : "ご希望 ") + (e.from ? e.from + "→" : "") + e.to;
      else if (rl) v += " ／ " + rl + "（在庫確認）";
      row("交換" + (i + 1), v);
    });
    if (S.kind === "return" && S.return_reason) row("返品理由", { size_ng: "サイズが合わない", image_ng: "イメージ違い", other: "その他" }[S.return_reason]);
    if (S.kind === "exchange") row("受取方法", S.receive === "store" ? "店舗（" + (S.receive_store || "") + "）" : S.receive === "ship" ? "配送希望" : "");

    var body = el("div");
    body.appendChild(box);
    var pol = policy[S.kind];
    var agree = el("label", "crt-agree");
    var cb = el("input"); cb.type = "checkbox";
    agree.appendChild(cb);
    agree.appendChild(el("span", null, esc(pol || "上記内容と返品・交換条件に同意します。") + " 上記条件に同意します。"));
    body.appendChild(agree);

    var backFn = S.kind === "exchange" ? (S.receive === "store" ? stepReceiveStore : stepReceive) : (S.manualMode ? stepManualItem : stepItems);
    var submit = nextBtn("この内容で送信する", function () { submit.disabled = true; doSubmit(d, submit); }, false);
    submit.disabled = true;
    cb.onchange = function () { submit.disabled = !cb.checked; };
    shell(3, "内容のご確認", body, [backBtn(backFn), submit]);
  }

  function doSubmit(data, btn) {
    root.appendChild(el("div", "crt-loading", "送信しています…"));
    fetch(HANDOFF, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ session_id: sessionId, data: data }) })
      .then(function (r) { return r.json(); })
      .then(function (res) { stepDone(res); })
      .catch(function () { if (btn) btn.disabled = false; alert("通信エラーが発生しました。お手数ですが時間をおいて再度お試しください。"); });
  }

  // ---- step: 完了 ----
  function stepDone(res) {
    root.innerHTML = "";
    root.appendChild(el("h1", "crt-h", "受付が完了しました"));
    var d = el("div", "crt-done");
    d.appendChild(el("div", "crt-note", "受付番号"));
    d.appendChild(el("div", "crt-done-ticket", esc(res.ticket || "-")));
    d.appendChild(el("div", "crt-note", "下記の内容をコピーして、公式LINEにお送りください。担当より折り返しご連絡します。"));
    root.appendChild(d);
    if (res.copyText) {
      var pre = el("div", "crt-copybox"); pre.textContent = res.copyText; root.appendChild(pre);
      var acts = el("div", "crt-actions");
      var copy = el("button", "crt-btn crt-btn-ghost", "内容をコピー");
      copy.onclick = function () { if (navigator.clipboard) navigator.clipboard.writeText(res.copyText).then(function () { copy.textContent = "コピーしました"; setTimeout(function () { copy.textContent = "内容をコピー"; }, 1800); }); };
      acts.appendChild(copy);
      if (res.lineUrl) {
        var line = el("a", "crt-btn crt-btn-line", "コピーしてLINEへ"); line.href = res.lineUrl; line.target = "_blank"; line.rel = "noopener";
        line.onclick = function () { if (navigator.clipboard) navigator.clipboard.writeText(res.copyText).catch(function () {}); };
        acts.appendChild(line);
      }
      root.appendChild(acts);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  stepKind();
})();
